import { Injectable } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class JQueryService {
  
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}

  get $(): any {
    if (isPlatformBrowser(this.platformId)) {
      return window['$'];
    }
    return null;
  }

  get jQuery(): any {
    if (isPlatformBrowser(this.platformId)) {
      return window['jQuery'];
    }
    return null;
  }

  /**
   * Execute jQuery code safely, checking if jQuery is available first
   * @param callback Function to execute with jQuery
   */
  execute(callback: ($: any) => void): void {
    const $ = this.$;
    if ($) {
      callback($);
    } else {
      console.warn('jQuery is not available');
    }
  }
} 